import type { ChangelogEntry } from "../types";

/** Signalagentene lærer av avvisningene, signalene står i listen, og oppfølgingskortet får signalkortets form. */
export const SIGNALER_LAERER_2026_10: ChangelogEntry = {
  id: "2026-10-27-signaler-laerer",
  date: "2026-10-27",
  title: "Signalene lærer av det dere avviser",
  summary:
    "Etter Avvis kan du si hvorfor, og agentene får de siste avviste og tatte signalene som eksempler. Signalene står i listen ved siden av køen, og oppfølgingskortet ser ut som signalkortet.",
  sections: [
    {
      heading: "Salgsmuligheter",
      minRole: "user",
      items: [
        {
          title: "«Hvorfor?» etter Avvis",
          kind: "nytt",
          featureFlag: "feature_crm_signaler",
          body: "Etter at du har avvist et signal, kan du velge For lite for video, Feil tidspunkt, Kjenner til det, Ikke min kunde eller Annet. Det er frivillig, og meldingen forsvinner etter seks sekunder.",
        },
        {
          title: "Agentene lærer hva som er salgbart",
          kind: "forbedret",
          featureFlag: "feature_crm_signaler",
          body: "Agentene har fått en fast regel om hva som er salgbart for et videoproduksjonsselskap, og ser de siste 15 signalene dere avviste og de siste 15 dere tok. Studentkvelder, kurs og webinarer skal ikke lenger bli signaler.",
        },
        {
          title: "Signalene står i listen",
          kind: "nytt",
          featureFlag: "feature_crm_signaler",
          body: "Under ukens oppfølginger står «Signaler i køen» med antallet. Klikk et signal for å se det med en gang, også når du har åpne oppfølginger.",
        },
        {
          title: "Oppfølgingskortet ser ut som signalkortet",
          kind: "forbedret",
          featureFlag: "feature_crm_ko_pipe",
          body: "Kunden med logo, oppfølgingen i en grå boks, kontakt med telefonnummer, tidligere verdi og siste kontakt, og store knapper. «Tok det på tlf» heter nå «Ring», og «Se mailutkast» heter «E-post». Er oppfølgingen en samtale, står Ring først.",
        },
      ],
    },
  ],
};
